export enum WebhookEvent {
  NewCandidate = 'new_candidate',
  CandidateAssigned = 'candidate_assigned',
  CandidateMoved = 'candidate_moved',
}

export const WEBHOOK_EVENTS = [
  WebhookEvent.NewCandidate,
  WebhookEvent.CandidateAssigned,
  WebhookEvent.CandidateMoved,
];
